import { render, staticRenderFns } from "./section10Popup.vue?vue&type=template&id=0d656081&scoped=true"
import script from "./section10Popup.vue?vue&type=script&lang=js"
export * from "./section10Popup.vue?vue&type=script&lang=js"
import style0 from "./section10Popup.vue?vue&type=style&index=0&id=0d656081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d656081",
  null
  
)

export default component.exports